export default __webpack_public_path__ + "static/media/vol1_textbook.c3674727.png";